/**
 * `apps/api/src/lib/labor-hours.ts` のミラー実装 (表示専用プレビュー用)。
 * ⚠️ §8-134: 演算子の意味論だけでなく入力値の正規化もサーバーと完全に一致させること。
 * サーバー側 (`calcLaborMinutes`/`resolveAutoDeductBreakMinutes`) を変更したら、必ずこのファイルも
 * 同じ diff で更新する。構造をサーバー側と1:1に保ち、差分を目視で突き合わせられるようにしてある。
 */

export type BreakMode = 'auto_deduct' | 'clock';
export type BreakRule = { overMinutes: number; breakMinutes: number };

/** 拘束時間 (durationMinutes) に対し、適用される最大の閾値 (overMinutes) を満たすルールの
 *  breakMinutes を採用する (該当ルールが無ければ 0)。 */
export const resolveAutoDeductBreakMinutes = (durationMinutes: number, rules: BreakRule[]): number => {
  const applicable = rules
    .filter((r) => durationMinutes > r.overMinutes)
    .sort((a, b) => b.overMinutes - a.overMinutes);
  return applicable[0]?.breakMinutes ?? 0;
};

/** 拘束時間 (startAt〜endAt、ISO8601) から実労働分を算出する。
 *  ⚠️ breakMode='auto_deduct' のときは breakMinutes (入力値) を無視し breakRules から自動算出する。 */
export const calcLaborMinutes = (
  startAt: string, endAt: string, breakMinutes: number, breakMode: BreakMode = 'clock',
  breakRules: BreakRule[] = [],
): number => {
  const durationMinutes = Math.round((new Date(endAt).getTime() - new Date(startAt).getTime()) / 60000);
  if (breakMode === 'auto_deduct') {
    return Math.max(0, durationMinutes - resolveAutoDeductBreakMinutes(durationMinutes, breakRules));
  }
  return Math.max(0, durationMinutes - Math.max(0, breakMinutes));
};
